import collection$1 from '../internals/collection.js';
import collectionStrong$1 from '../internals/collection-strong.js';

var collection = collection$1;
var collectionStrong = collectionStrong$1; // `Map` constructor
// https://tc39.es/ecma262/#sec-map-objects

collection('Map', function (init) {
  return function Map() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
}, collectionStrong);
